import { useContext } from "react";
import { MenuContext } from "../../Context/Menucontext";
import "./Contactpop.css"



const ContactPop = () => {
    const {setIspopUp} = useContext(MenuContext)
    return ( 
        <div className="Contact-pop" onClick={() => setIspopUp(false)}>
            <h3>Contact Information</h3>
            <div className="con">
                <div className="box">
                    <p>Email</p>
                    <span>
                        <p>example@email.com</p>
                        <i className="fa-regular fa-envelope"></i>
                    </span>
                </div>
                <div className="box">
                    <p>Phone number</p>
                    <span>
                        <p>+234 (800) 000 0000</p>
                        <i className="fa-solid fa-phone"></i>
                    </span>
                </div>
                <div className="box">
                    <p>Company name</p>
                    <span>
                        <p>Company name</p>
                        
                    </span>
                </div>
                <div className="box">
                    <p>Contact person</p>
                    <span>
                        <p>Full name</p>
                        
                    </span>
                </div>
            </div>
        </div>
     );
}
 
export default ContactPop;